module.exports = __webpack_public_path__ + "static/media/PlutoBold.5755094e.svg";